<template>
  <div id="app">
    <landing_links></landing_links>   
    <landing_objectives></landing_objectives>
    <!-- <landing_cloud :words="words_data"></landing_cloud>    -->
    <landing_interests></landing_interests>   
    <landing_timeline :contents="cv_data" ></landing_timeline>
    
    <!-- <projects :contents="project_data"></projects> -->
    <!-- <landing_table :contents="table_data"></landing_table>        -->
    <landing_gallery></landing_gallery>
    <landing_contact></landing_contact>
    <landing_footer></landing_footer>

  </div>
</template>

<script>
import axios from 'axios';
import words_json from "./assets/json/cloudwords.json";
import cv_json from "./assets/json/cv.json";
import projects_json from "./assets/json/all-projects-zh.json";
import toc_json from "./assets/json/projects-zh-toc.json";

import { getParameterByName, apply_theme } from "./assets/js/utils.js";

import landing_links from "./components/landing_links.vue";
import landing_table from "./components/landing_table.vue";
import landing_interests from "./components/landing_interests.vue";

import landing_cloud from "./components/landing_cloud.vue";
import landing_timeline from "./components/landing_timeline.vue";
import landing_gallery from "./components/landing_gallery.vue";
import landing_footer from "./components/landing_footer.vue";
import landing_projects from "./components/landing_projects.vue";
import landing_contact from "./components/landing_contact.vue";
import landing_objectives from "./components/landing_objectives.vue";

export default {
  name: "app",
  data() {
    return {
      // front_data: { },
      // timeline_data: [],
      cv_data: [],
      project_data: [],
      toc_data: {},
      words_data:[]
    };
  },
  computed: {
    table_data() {
        return   {
          project_data: this.project_data, 
          toc_data:this.toc_data
        };
    }
  },

  created() {
    apply_theme("./dist/theme/");
    this.get_json();
    // document.getElementById('waiting').innerText = '';
  },
  methods: {
    get_json() {
      const vm = this;

      axios.get(projects_json, {responseType: 'json'}).then(function(response) {
        vm.project_data = response.data;
      }).catch(function (error) {  console.log(error);  });

      axios.get(cv_json, {responseType: 'json'}).then(function(response) {
        vm.cv_data = response.data;
      }).catch(function (error) {  console.log(error);  });

      axios.get(toc_json, {responseType: 'json'}).then(function(response) {
        vm.toc_data = response.data;
      }).catch(function (error) {  console.log(error);  });

      axios.get(words_json, {responseType: 'json'}).then(function(response) {
        vm.words_data = response.data;
      }).catch(function (error) {  console.log(error);  });
      
    }
  },
  components: {
    landing_links,
    landing_table,
    landing_interests,
    landing_cloud,
    landing_timeline,
    landing_gallery,
    landing_projects,
    landing_contact,
    landing_objectives,
    landing_footer
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue